
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import TransferItem from './components/TransferItem.vue'
import useOpenInfo from '@/hooks/openInfo'
import { setApptitle } from '@/utils/native-app'
import * as storage from '@/utils/storage'
import { useMutation } from '@vue/apollo-composable'
import { mutateApi } from '@/graphql/mutation'
import { FormType } from '@/enum'

export default defineComponent({
  components: { TransferItem },
  setup () {
    const router = useRouter()
    const { openType, step, title, saveCommonOfVuex, meta } = useOpenInfo()
    const commonParams = ref()
    // 获取storage中的formType,用来区分普通开户和投资移民户
    const formType = computed(() => storage.get('formType'))
    const handleNext = () => {
      commonParams.value = {
        openType: openType.value,
        openStatus: 0,
        btnText: '身份核实',
        remark: '距离开户成功只差最后一步',
        step
      }
      mutate({
        params: {
          formType: formType.value,
          meta: meta.value,
          content: JSON.stringify(commonParams.value)
        }
      })
    }

    const { mutate, onDone } = useMutation(mutateApi.saveClientFormDraft)
    onDone((res) => {
      const { saveClientFormDraft } = res.data
      if (saveClientFormDraft.ok) {
        saveCommonOfVuex({ info: commonParams.value })
        router.push({ name: 'transfer-pro' })
      }
    })
    onMounted(() => {
      setApptitle(title)
    })

    return { handleNext, formType, FormType }
  }
})
